import { setDefaultValues } from 'loader-base';

const setDefaultValuesEc = function setDefaultValuesEc(loaderConfig) {
    setDefaultValues(loaderConfig);
    loaderConfig.additionalComponents = loaderConfig.additionalComponents || [];
    loaderConfig.ignore = loaderConfig.ignore || [];
    loaderConfig.css.toggleCssWithComponent = loaderConfig.css.toggleCssWithComponent || false;
    if (loaderConfig.componentSource.useClientSpecificBundle) {
        // Configuration should already be included in the bundle.
        loaderConfig.configuration.source.type = 'none';
    }
};

export { setDefaultValuesEc as default };



// WEBPACK FOOTER //
// ./src/default-values-ec.js